import React from 'react';
import { useFormikContext } from 'formik';
import {
  FormGroup,
  Input,
  FormText,
} from 'reactstrap';
import { CardTitle } from '@cordata/buffet';

const NoteFormatterField = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      <CardTitle>Note Formatter</CardTitle>

      <FormGroup>
        <Input
          type="textarea"
          name="noteFormatter"
          id="noteFormatter"
          rows={3}
          value={values.noteFormatter || ''}
          onChange={e => setFieldValue('noteFormatter', e.target.value)}
          style={{ fontFamily: 'monospace', fontSize: '0.85em' }}
          placeholder={'e.g. Patient deceased{% if after.death_date %} on {{ after.death_date }}{% endif %}'}
        />
        <FormText>
          Liquid template rendered against the event dict for notification text.
          Leave blank to use topic label as the notification note.
          Can also be a registered Python formatter name.
        </FormText>
      </FormGroup>
    </>
  );
};

export default NoteFormatterField;
